module.exports = __webpack_public_path__ + "img/samsung-galaxy-grand2.eacbd4ee.jpg";